import FColumnCellMDP from '../FColumnCellMDP';

export default class FCellLinksMDP implements FColumnCellMDP {
    onClickCopy: (item: any) => any;
    onClickWhatsApp: (item: any) => any;
    dataSelectorKeyToCopy?: string;
    copyTooltipText?: string;
    constructor({
        onClickCopy,
        onClickWhatsApp,
        dataSelectorKeyToCopy,
        tooltipText
    }: {
        onClickCopy: (item: any) => any;
        onClickWhatsApp: (item: any) => any;
        dataSelectorKeyToCopy?: string;
        tooltipText?: string;
    }) {
        this.onClickCopy = onClickCopy;
        this.onClickWhatsApp = onClickWhatsApp;
        this.dataSelectorKeyToCopy = dataSelectorKeyToCopy;
        this.copyTooltipText = tooltipText;
    }
    componentName: string = "FCellLinks";
    getMetaData(): object {
        return {
            componentName: this.componentName,
            props: {
                onClickCopy: this.onClickCopy,
                onClickWhatsApp: this.onClickWhatsApp,
                dataSelectorKeyToCopy: this.dataSelectorKeyToCopy,
                copyTooltipText: this.copyTooltipText
            }
        }
    }
}

